/**
 * WHAT THIS DEVICE REMEMBERS — loyalty only.
 *
 * `rememberMe` keeps ONLY the email and the first name, so the next tap on the
 * card opens the PIN sign-in already filled in. Never the PIN.
 *
 * `handOverSession` carries the session the confirm screen was just handed to
 * the portal. It lives in sessionStorage, so a reload in the same tab keeps the
 * member signed in and closing the browser ends it.
 *
 * Every call is wrapped: with storage blocked the portal still works, the
 * member just signs in with the PIN as before.
 */
const ME = 'yot.loyalty.me';
const SESSION = 'yot.loyalty.session';

export const rememberedMe = () => {
    try { return JSON.parse(window.localStorage.getItem(ME) || 'null'); } catch { return null; }
};

export const rememberMe = (value) => {
    try {
        if (value && value.email) window.localStorage.setItem(ME, JSON.stringify(value));
        else window.localStorage.removeItem(ME);
    } catch { /* storage blocked — the portal still works */ }
};

export const handOverSession = (token) => {
    try {
        if (token) window.sessionStorage.setItem(SESSION, token);
        else window.sessionStorage.removeItem(SESSION);
    } catch { /* storage blocked — the portal still works */ }
};

export const heldSession = () => {
    try { return window.sessionStorage.getItem(SESSION) || ''; } catch { return ''; }
};
